// Leaderboard nickname dialog: a DOM form over the canvas, styled as pixel
// art (CSS in index.html, #name-entry). DOM rather than canvas because only
// a real <input> brings up the phone keyboard (any language, paste); not
// window.prompt because the native prompt vanishes when a phone is rotated
// and looks nothing like the game. Resolves with the trimmed text, or ''
// when skipped (the skip button, Esc, an empty submit, the page going away).
import { pixelateHeading } from './pixel-text.js';

// Same gold bands as the menu title, small: a one-line heading.
const TITLE_STYLE = {
  key: 'name-title',
  bands: ['#ffe866', '#ffd700', '#ffc400', '#f0a800'],
  shadow: '#4a2a00',
  shadowCells: 1,
  outline: '#140a00',
};

export function askPlayerName({ title, placeholder, ok, skip, maxLength }) {
  return new Promise((resolve) => {
    const form = document.createElement('form');
    form.id = 'name-entry';
    form.autocomplete = 'off';

    const heading = document.createElement('h2');
    heading.textContent = title;

    const row = document.createElement('div');
    row.className = 'row';
    const input = document.createElement('input');
    input.type = 'text';
    input.maxLength = maxLength;
    input.placeholder = placeholder;
    input.enterKeyHint = 'done';
    input.spellcheck = false;
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('aria-label', title);
    const okBtn = document.createElement('button');
    okBtn.type = 'submit';
    okBtn.className = 'ok';
    okBtn.textContent = ok;
    row.append(input, okBtn);

    const skipBtn = document.createElement('button');
    skipBtn.type = 'button';
    skipBtn.className = 'skip';
    skipBtn.textContent = skip;

    form.append(heading, row, skipBtn);
    document.body.appendChild(form);
    const disposeTitle = pixelateHeading(heading, TITLE_STYLE);

    let done = false;
    const onHide = () => finish('');
    const finish = (name) => {
      if (done) return;
      done = true;
      window.removeEventListener('pagehide', onHide);
      disposeTitle();
      form.remove();
      resolve(name);
    };
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      finish(input.value.trim());
    });
    skipBtn.addEventListener('click', () => finish(''));
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') finish('');
    });
    window.addEventListener('pagehide', onHide);

    // Desktop: type straight away. On touch the keyboard would cover the
    // panel before it's read — the player taps the field instead.
    if (!window.matchMedia || !window.matchMedia('(pointer: coarse)').matches) {
      input.focus();
    }
  });
}
